import Heading from "common/components/Typography/Heading/Heading";
import React from "react";
import { Link } from "react-router-dom";
import styles from './RegistroDocumentoView.module.scss';

export default function RegistroDocumentoView(props){

    return <div className={styles.viewwrapper}>
        <div>
            <Heading variant="h4" override>Por favor, Seleccione el tipo de documento a registrar:</Heading> 
        </div>
        <Link  to="/registro-documento/factura" className="btn btn-outline-primary">Factura</Link>
        <Link  to="/registro-documento/recibo" className="btn btn-outline-primary">Recibo/Invoice</Link>
    </div>;


}